import React from 'react';


import { getPublicRental } from "../../../data/loca/rentals";
import { paymentCall } from "../../../data/loca/sumup";
import { calendarStrings } from '../../../services/calendarStrings';
import { default as SumupCard } from "../../../routes/modules/SumupCard";

import {
    useLoaderData
} from "react-router-dom";

import Moment from 'react-moment';
import 'moment/locale/fr';
export async function loader({ params }) {

    const rental = await getPublicRental(params.rentalId);

    let resp = await paymentCall(params.rentalId);
    var error = resp.error;
    
    var Status = resp.status;
    var SumUpCheckoutId = resp.sumUpCheckoutId;

    return { Status, rental, error, SumUpCheckoutId };
}


export default function StripePayment() {
    const {  Status, rental, error, SumUpCheckoutId } = useLoaderData();


    return (
        <div className="financialForm">
            <div id="thumbnail">
                <img className="depositImg" height="192" key={rental.publicId} alt={rental.name} src={rental.base64Picture || null} />
             
                

                <div>
                    <div className="partHeaderPayment">
                        <h1>Location : {rental.name}</h1>

                  
                        <div id="thumbnail-form">
                            <label>Par :&nbsp;<b>{rental.clientFirstname} {rental.clientLastname}</b></label> ({rental.serviceName})
                        
                        </div>
                        <label>
                        Date :&nbsp;
                            <Moment locale="fr" calendar={calendarStrings}>
                                {new Date(rental.startDate)}
                            </Moment>
                            &nbsp;jusqu'&agrave;&nbsp;
                            <Moment locale="fr" calendar={calendarStrings}>
                                {new Date(rental.endDate)}
                            </Moment>

                        </label>
                    </div>
                    {Status === "Error" ? (
                        <h3>
                            {error}
                        </h3>
                    )
                        : (
                            <>
                        
                    <div className="contentForm"></div>
                    

                    {Status === "Created" ? (
                                    <>
                                        <div className="partHeaderPayment">
                            <h2>Je paie ma location par carte</h2>
                                            <p>Montant  : {rental.remainingToBePaidCents / 100}€</p>
                                        </div>
                                        <SumupCard checkoutId={SumUpCheckoutId} />

                        </>
                    ) 
                        : (
                            <>
                                <h2>Paiement effectué avec succès !</h2>
                            </>
                        )}

                            </>
                        )}
                </div>
            </div>
        </div>
    )            
}